export const mapOrderToQuoteData = (order, userInitials = "JH", quoteSequence = 1) => {
    if (!order) {
        console.warn('⚠️ QuoteDataMapper: Order data bulunamadı');
        return null;
    }

    try {
        // Tarih formatı
        const now = new Date();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const displayDate = now.toLocaleDateString('en-US');

        // Order number
        const orderNumber = order.orderNumber?.replace('#', '') || '0000';

        // ⭐ DEFAULT OLARAK -001, -002 EKLE
        const defaultPoNumber = `${userInitials}-${month}${day}-${orderNumber}-${String(quoteSequence).padStart(3, '0')}`;

        // Müşteri adı
        const customerName = `${order.customerFirstName || ''} ${order.customerLastName || ''}`.trim();

        return {
            // Header
            headerTitle: "QUOTE",
            headerSubtitle: "-",
            companyName: "Professional Medical Supplies",
            companyTagline: "Trusted Healthcare Partner",

            // Company info
            leftHeader: "MEDIDEPOT",
            companyInfo: "Palmyra 1 Trading LLC\n2224 NJ-37 E, Suite 3\nToms River, NJ, 08753\nhttps://medidepot.com",

            // ⭐ DEFAULT -001, kullanıcı değiştirebilir
            date: displayDate,
            poNumber: defaultPoNumber, // JH-1225-1329-001

            // Customer
            customerName: customerName,

            // Items
            items: order.items?.map(item => ({
                itemCode: item.sku || '',
                description: item.productTitle || '',
                quantity: item.quantity || 0,
                unitPrice: item.unitPrice || 0,
                total: (item.quantity || 0) * (item.unitPrice || 0)
            })) || [],

            // Other
            shipping: 0,
            comments: "",

            // Editable labels
            signatureLabel1: "Adult Signature",
            signatureValue1: "Required",
            signatureLabel2: "Liftgate Service",
            signatureValue2: "",

            // Table headers (elle değiştirilebilir)
            itemCodeLabel: "ITEM CODE",
            descriptionLabel: "DESCRIPTION",
            qtyLabel: "UNIT QTY",
            unitPriceLabel: "UNIT PRICE",
            totalLabel: "TOTAL"
        };
    } catch (error) {
        console.error('❌ QuoteDataMapper error:', error);
        return null;
    }
};